import React from 'react';

const CarouselOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="M5 3.792h5.25c.644 0 1.167.523 1.167 1.166v5.25c0 .645-.523 1.167-1.167 1.167H5a1.167 1.167 0 0 1-1.167-1.167v-5.25C3.833 4.315 4.356 3.792 5 3.792Z"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.042 1.75h-5.25c-.967 0-1.75.784-1.75 1.75v5.25"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CarouselOutlined;
